import template from './smallScreenPopup.html';

class SmallScreenPopupController {
    constructor() {
        'ngInject';
    }
}

export const SmallScreenPopupComponent = {
    name: 'smallScreenPopup',
    component: {
        template: template,
        controller: SmallScreenPopupController,
        bindings: {
            patient: '<',
            expired: '<',
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/smallScreenPopup.component.js